import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const Footer = () => {
  return (
    <footer
      className="relative overflow-hidden bg-card border-t border-border mt-20"
      data-testid="footer"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 pb-28">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <img
                src="/images/bt-logo.png"
                alt="BT Chilli Logo"
                className="w-20 h-20 object-contain"
              />
              <div>
                <h3 className="text-xl font-semibold text-foreground">
                  BT Premium Chilli Store
                </h3>
                <p className="text-xs text-secondary tracking-widest uppercase">
                  Premium Quality Since 2024
                </p>
              </div>
            </div>

            <p className="text-muted-foreground text-sm leading-relaxed max-w-md">
              Premium mirchi powder crafted for rich color, bold aroma, and authentic taste.
              Inspired by traditional spice heritage and packed for everyday kitchens that love real flavor.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4 uppercase tracking-wider">
              Quick Links
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/products"
                  className="text-sm text-muted-foreground hover:text-secondary transition-colors"
                >
                  Shop Now
                </Link>
              </li>
              <li>
                <Link
                  to="/orders"
                  className="text-sm text-muted-foreground hover:text-secondary transition-colors"
                >
                  Track Order
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-muted-foreground hover:text-secondary transition-colors"
                >
                  About Us
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-muted-foreground hover:text-secondary transition-colors"
                >
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold text-foreground mb-4 uppercase tracking-wider">
              Contact Us
            </h4>
            <ul className="space-y-3">
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Phone className="w-4 h-4 text-secondary" />
                +1 910 (377)-7966
              </li>
              <li className="flex items-center gap-3 text-sm text-muted-foreground">
                <Mail className="w-4 h-4 text-secondary" />
                supportbtchilli@gmail.com
              </li>
              <li className="flex items-start gap-3 text-sm text-muted-foreground">
                <MapPin className="w-4 h-4 text-secondary mt-0.5" />
                <span>Guntur, Andhra Pradesh</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © 2026 BT Premium Chilli Store. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              Terms of Service
            </a>
            <a href="#" className="text-xs text-muted-foreground hover:text-foreground transition-colors">
              Refund Policy
            </a>
          </div>
        </div>
      </div>

      {/* Flames image layer */}
      <div
        className="footer-flame-image"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/images/footer-flames.png)`,
        }}
      ></div>

      {/* Glow above flames */}
      <div className="footer-flame-glow"></div>

      {/* Sparks */}
      <div className="footer-fire-sparks">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
    </footer>
  );
};

export default Footer;